import './style.css';

import { observer } from 'mobx-react';
import React from 'react';

export interface IProps {
  src?: any;
}

@observer
class Code extends React.Component<IProps> {
  static defaultProps: Partial<IProps> = {
    src: null
  };

  render() {
    return <pre className="json-output">{JSON.stringify(this.props.src, null, '  ')}</pre>;
  }
}

export default Code;

export const { defaultProps } = Code;
